import { api } from "../lib";

export type GrossingDocumentRenderKind = "pdf" | "image" | "unsupported";

export interface GrossingDocumentMetadata {
  id: string;
  kind: GrossingDocumentRenderKind;
  mimeType: string;
  createdAt: string;
  label: string;
}

export const grossingRequisitionsService = {
  list: (caseId: string): Promise<GrossingDocumentMetadata[]> =>
    api.get<GrossingDocumentMetadata[]>(
      `/workflows/grossing/${caseId}/requisitions`
    ),

  createViewUrl: (caseId: string, fileId: string): Promise<{ url: string }> =>
    api.post<{ url: string }>(
      `/workflows/grossing/${caseId}/requisitions/${fileId}/view-url`
    ),
};
